<template>
  <div class="fs14">
    {{showValue}}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import filters from '../filters.js'
export default {
  name: 'v-statictext',
  props: ['params', 'rowData'],
  filters,
  computed: {
    ...mapGetters([
      'brands'
    ]),
    showValue() {
      return this.params.sureRelation
        ? this.params.value.replace('xxx', this.rowData[this.params.sureRelation])
        : this.params.value
    }
  }
}
</script>

<style lang="less">
@import "../../../styles/index.less";
</style>
